import "./App.css";
import Dashboard from "./MainSitePage";

function App() {
  return <Dashboard />;
}

export default App;
